import React, { useRef } from "react";
import { AsignationTableRow } from "./AsignationTableRow";

export const AsignationTable = ({
	studentCourses = [],
	setCourseAsignmentToEdit,
	openModal2,
	deleteAsignment,
	setShowEvaluationResult,
	openModal3,
	askQuiz,
}) => {
	const tbodyRef = useRef(null);

	const handleSearchDirect = (e) => {
		const query = e.target.value.toLowerCase();

		if (!tbodyRef.current) return;

		// Selecciona automáticamente cualquier fila <tr> dentro del cuerpo de la tabla
		const rows = tbodyRef.current.querySelectorAll("tr");

		studentCourses.forEach((item, index) => {
			const row = rows[index];
			if (!row) return;

			const course = item.course ? item.course.toLowerCase() : "";
			const status = item.status ? item.status.toLowerCase() : "";
			const nameStudent = item.nameStudent
				? item.nameStudent.toLowerCase()
				: "";
			const student = item.student ? item.student.toLowerCase() : "";

			const matches =
				course.includes(query) ||
				status.includes(query) ||
				nameStudent.includes(query) ||
				student.includes(query);

			if (matches) {
				row.style.display = "";
			} else {
				row.style.display = "none";
			}
		});
	};

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					onChange={handleSearchDirect}
					className="search-box"
					placeholder="Buscar por curso, estudiante..."
				/>
			</div>
			<h3 className="titulo1">LISTA DE CURSOS</h3>

			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments02">Curso</th>
						<th className="titleTableDocuments02">Usuario</th>
						<th className="titleTableDocuments02">Habilitado</th>
						<th className="titleTableDocuments02">Nota</th>
						<th className="titleTableDocuments02">Tiempo</th>
						<th className="titleTableDocuments02">Veces</th>
						<th className="titleTableDocuments02">Hecho el:</th>
						<th className="titleTableDocuments02">Estado</th>
						<th className="titleTableDocuments03">Acción</th>
					</tr>
				</thead>
				<tbody ref={tbodyRef}>
					{studentCourses.length > 0 ? (
						studentCourses.map((el) => (
							<AsignationTableRow
								key={el.id}
								el={el}
								setCourseAsignmentToEdit={setCourseAsignmentToEdit}
								openModal2={openModal2}
								deleteAsignment={deleteAsignment}
								setShowEvaluationResult={setShowEvaluationResult}
								openModal3={openModal3}
								askQuiz={askQuiz}
							/>
						))
					) : (
						<tr>
							<td colSpan="9" style={{ textAlign: "center", padding: "10px" }}>
								Sin datos
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

// import React, { useEffect, useState } from "react";
// import { AsignationTableRow } from "./AsignationTableRow";

// export const AsignationTable = ({
// 	studentCourses,
// 	setCourseAsignmentToEdit,
// 	openModal2,
// 	deleteAsignment,
// 	setShowEvaluationResult,
// 	openModal3,
// 	askQuiz,
// }) => {
// 	const [data, setData] = useState(studentCourses);
// 	const jsonValue = localStorage.getItem("userLocal");
// 	const localUser = JSON.parse(jsonValue);
// 	useEffect(() => {
// 		setData(studentCourses);
// 	}, [studentCourses]);

// 	function handleSearch(e) {
// 		if (e.target.value === "") {
// 			return setData(studentCourses);
// 		}
// 		try {
// 			setData(
// 				studentCourses.filter(
// 					(item) =>
// 						item.course.toLowerCase().includes(e.target.value) ||
// 						item.status.toLowerCase().includes(e.target.value) ||
// 						item.nameStudent.toLowerCase().includes(e.target.value) ||
// 						item.student.toLowerCase().includes(e.target.value)
// 				)
// 			);
// 		} catch (error) {}
// 	}

// 	return (
// 		<div>
// 			{/* {console.log("data", data)} */}
// 			<div className="document-search">
// 				<h2 className="title-search">Buscar</h2>
// 				<input
// 					type="search"
// 					name=""
// 					id=""
// 					onChange={handleSearch}
// 					className="search-box"
// 				/>
// 			</div>
// 			<h3 className="titulo1">LISTA DE CURSOS</h3>

// 			<table className="tabla-procesos">
// 				<thead>
// 					<tr className="fila-tabla-procesos">
// 						{/* <th className="titleTableDocuments01">Area</th> */}
// 						<th className="titleTableDocuments02">Curso</th>
// 						<th className="titleTableDocuments02">Usuario</th>
// 						{/* <th className="titleTableDocuments02">Correo</th> */}
// 						<th className="titleTableDocuments02">Habilitado</th>
// 						{/* <th className="titleTableDocuments02">Hasta</th> */}
// 						<th className="titleTableDocuments02">Nota</th>
// 						<th className="titleTableDocuments02">Tiempo</th>
// 						<th className="titleTableDocuments02">Veces</th>
// 						<th className="titleTableDocuments02">Hecho el:</th>
// 						<th className="titleTableDocuments02">Estado</th>
// 						<th className="titleTableDocuments03">Acción</th>
// 					</tr>
// 				</thead>
// 				<tbody>
// 					{data.length > 0 ? (
// 						data.map((el) => (
// 							<AsignationTableRow
// 								key={el.id}
// 								el={el}
// 								setCourseAsignmentToEdit={setCourseAsignmentToEdit}
// 								openModal2={openModal2}
// 								deleteAsignment={deleteAsignment}
// 								setShowEvaluationResult={setShowEvaluationResult}
// 								openModal3={openModal3}
// 								askQuiz={askQuiz}
// 							/>
// 						))
// 					) : (
// 						<tr>
// 							<td colSpan="3">Sin datos</td>
// 						</tr>
// 					)}
// 				</tbody>
// 			</table>
// 		</div>
// 	);
// };
